import { useLayoutEffect, useState } from "react";

const useRoleTheme = (clientId: string | undefined) => {
  const [isReady, setIsReady] = useState(false);

  useLayoutEffect(() => {
    const htmlElement = document.documentElement;

    if (!clientId) {
      htmlElement.removeAttribute("data-role");
      setIsReady(true);
      return;
    }

    const themeMapping: Record<string, string> = {
      "pao-admision-epg-web": "candidate_epg",
      "pao-admision-web": "candidate"
    };

    const theme = themeMapping[clientId] || clientId;

    htmlElement.setAttribute("data-role", theme);
    setIsReady(true);
    
    return () => {
      htmlElement.removeAttribute("data-role");
    };
  }, [clientId]);

  return { isReady };
};

export default useRoleTheme;
